var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isOffice && !_vm.isOfficial
      ? _c("p", { staticClass: "text-muted small mb-4" }, [
          _vm._v(
            " Define a quién se reenviará el flujo y cómo continuará el proceso. "
          )
        ])
      : _vm._e(),
    _c("div", { staticClass: "row" }, [
      !_vm.isOffice && !_vm.isOfficial
        ? _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Tipo de destinatario",
                    "label-cols": "12",
                    "label-class": "font-weight-semibold"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex" },
                    [
                      _c(
                        "b-form-radio",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            value: _vm.stepTypes.usuario,
                            button: "",
                            "button-variant": "outline-primary"
                          },
                          on: { input: _vm.emitData },
                          model: {
                            value: _vm.resendSubject.type,
                            callback: function($$v) {
                              _vm.$set(_vm.resendSubject, "type", $$v)
                            },
                            expression: "resendSubject.type"
                          }
                        },
                        [_vm._v(" Usuario ")]
                      ),
                      _c(
                        "b-form-radio",
                        {
                          attrs: {
                            value: _vm.stepTypes.grupo,
                            button: "",
                            "button-variant": "outline-primary"
                          },
                          on: { input: _vm.emitData },
                          model: {
                            value: _vm.resendSubject.type,
                            callback: function($$v) {
                              _vm.$set(_vm.resendSubject, "type", $$v)
                            },
                            expression: "resendSubject.type"
                          }
                        },
                        [_vm._v(" Grupo ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "col-6" }, [
        _vm.resendSubject.type === _vm.stepTypes.usuario &&
        !_vm.isOffice &&
        !_vm.isOfficial
          ? _c(
              "div",
              [
                _c("list-user", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  ref: "resendName",
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    label: "Usuario",
                    name: "userStep"
                  },
                  on: { input: _vm.emitSelectData },
                  model: {
                    value: _vm.resendSubject.id,
                    callback: function($$v) {
                      _vm.$set(_vm.resendSubject, "id", $$v)
                    },
                    expression: "resendSubject.id"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.resendSubject.type === _vm.stepTypes.grupo &&
        !_vm.isOffice &&
        !_vm.isOfficial
          ? _c(
              "div",
              [
                _c("list-groups", {
                  ref: "resendName",
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    label: "Grupo",
                    name: "groupStep"
                  },
                  on: { input: _vm.emitSelectData },
                  model: {
                    value: _vm.resendSubject.id,
                    callback: function($$v) {
                      _vm.$set(_vm.resendSubject, "id", $$v)
                    },
                    expression: "resendSubject.id"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.isOffice && !_vm.isOfficial
          ? _c(
              "div",
              [
                _c("list-groups", {
                  ref: "resendName",
                  staticClass: "w-100",
                  attrs: {
                    "filter-office": true,
                    "actual-office": _vm.stepId.paso.tipoValorResponsableId,
                    disabled: _vm.searchingConfig,
                    autocomplete: "",
                    label: _vm.officeLabel,
                    name: "groupStep",
                    "type-list": _vm.officeType.codeType,
                    "office-type": _vm.officeType.type
                  },
                  on: { input: _vm.emitSelectData },
                  model: {
                    value: _vm.resendSubject.id,
                    callback: function($$v) {
                      _vm.$set(_vm.resendSubject, "id", $$v)
                    },
                    expression: "resendSubject.id"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "col-12 mt-2" }, [
        _vm.searchingConfig
          ? _c("small", { staticClass: "text-warning" }, [
              _vm._v(
                " Estamos buscando si esta oficina cuenta con la configuración de folios para este tipo de documento "
              )
            ])
          : _vm._e(),
        _vm.error.message !== ""
          ? _c(
              "div",
              {
                staticClass:
                  "con-text-validation span-text-validation-danger\n               vs-input--text-validation-span v-enter-to text-right",
                staticStyle: { height: "32px" }
              },
              [
                _c("span", { staticClass: "span-text-validation" }, [
                  _vm._v(" " + _vm._s(_vm.error.message) + " ")
                ])
              ]
            )
          : _vm._e()
      ]),
      !_vm.isOffice && !_vm.isOfficial
        ? _c("div", { staticClass: "col-12 mt-2" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-6 mb-3" },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Tipo de paso a asignar",
                        "label-for": "rol-tipo-select",
                        "label-cols": "12",
                        "label-class": "font-weight-semibold",
                        description:
                          "Define el rol con el que actuará el nuevo destinatario."
                      }
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          staticClass: "w-100",
                          attrs: { id: "rol-tipo-select" },
                          on: { change: _vm.emitData },
                          model: {
                            value: _vm.resendSubject.tipoRol,
                            callback: function($$v) {
                              _vm.$set(_vm.resendSubject, "tipoRol", $$v)
                            },
                            expression: "resendSubject.tipoRol"
                          }
                        },
                        [
                          _c(
                            "b-form-select-option",
                            { attrs: { value: null, disabled: "" } },
                            [_vm._v(" Seleccione tipo de paso ")]
                          ),
                          _vm.canShowReviewer
                            ? _c(
                                "b-form-select-option",
                                { attrs: { value: _vm.rolTypesCode.revisor } },
                                [_vm._v(" Revisor ")]
                              )
                            : _vm._e(),
                          _vm.canShowApprover
                            ? _c(
                                "b-form-select-option",
                                {
                                  attrs: { value: _vm.rolTypesCode.aprobador }
                                },
                                [_vm._v(" Aprobador ")]
                              )
                            : _vm._e(),
                          _vm.canShowSigner
                            ? _c(
                                "b-form-select-option",
                                { attrs: { value: _vm.rolTypesCode.firmante } },
                                [_vm._v(" Firmante ")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-6 mb-3" },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Comportamiento del flujo",
                        "label-cols": "12",
                        "label-class": "font-weight-semibold"
                      }
                    },
                    [
                      _c("div", { staticClass: "d-flex flex-column" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex mb-1" },
                          [
                            _c(
                              "b-form-radio",
                              {
                                staticClass: "mr-2",
                                attrs: {
                                  value: true,
                                  button: "",
                                  "button-variant": "outline-primary"
                                },
                                on: { input: _vm.emitData },
                                model: {
                                  value: _vm.resendSubject.continueFlow,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.resendSubject,
                                      "continueFlow",
                                      $$v
                                    )
                                  },
                                  expression: "resendSubject.continueFlow"
                                }
                              },
                              [_vm._v(" Que continúe ")]
                            ),
                            _c(
                              "b-form-radio",
                              {
                                attrs: {
                                  value: false,
                                  button: "",
                                  "button-variant": "outline-primary"
                                },
                                on: { input: _vm.emitData },
                                model: {
                                  value: _vm.resendSubject.continueFlow,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.resendSubject,
                                      "continueFlow",
                                      $$v
                                    )
                                  },
                                  expression: "resendSubject.continueFlow"
                                }
                              },
                              [_vm._v(" Que vuelva a mí ")]
                            )
                          ],
                          1
                        ),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm.resendSubject.continueFlow === true
                            ? _c("span", [
                                _vm._v(" Si eliges que "),
                                _c("b", [_vm._v("continúe")]),
                                _vm._v(
                                  ", el flujo continuará al paso después de este. "
                                )
                              ])
                            : _c("span", [
                                _vm._v(" Si eliges que "),
                                _c("b", [_vm._v("vuelva a ti")]),
                                _vm._v(
                                  ", luego de que el usuario/grupo que selecciones apruebe, volverá este flujo a tu bandeja. "
                                )
                              ])
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm.isOfficial
        ? _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              [
                _c("list-group-users", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  ref: "resendName",
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    label: "Usuarios de la oficina",
                    name: "userStep",
                    "parent-value": _vm.officialOfficeId
                  },
                  on: { input: _vm.emitSelectData },
                  model: {
                    value: _vm.resendSubject.id,
                    callback: function($$v) {
                      _vm.$set(_vm.resendSubject, "id", $$v)
                    },
                    expression: "resendSubject.id"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }